import { gql } from '@apollo/client';

export const UPDATE_POST_REPLY_DRAFT_MUTATION = gql`
    mutation updatePostReplyDraft($input: UpdatePostReplyDraftInput) {
        updatePostReplyDraft(input: $input) {
            id
            parentPostId
            status
            categories
            hasStoryAnalysis
            article
            createdAt
            updatedAt
            username
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            textBlocksVersions {
                id
                blocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
            }
        }
    }
`;
